
export class AuthoritiesConfig {
	private authorities: Authorities;


	public getAuthorities() {
		return Authorities;
	}
}

export class RoutesGaurdConfig {

	private routesAndPermissions: RouteConfig[] = [
		{ path: 'outlet-manager/dashboard', permission: '' },
		{ path: 'outlet-manager/outlets', permission: '' },
		{ path: 'outlet-manager/savings', permission: '' },
		{ path: 'outlet-manager/loans', permission: Authorities.VIEW_LOANS },
		{ path: 'outlet-manager/general/wallet', permission: Authorities.VIEW_WALLET },
		{ path: 'outlet-manager/devices', permission: Authorities.VIEW_USER_DEVICES },

		{ path: 'agent/dashboard', permission: '' },
		{ path: 'agent/transactions', permission: Authorities.VIEW_AGENT_TRANSACTIONS },
		{ path: 'agent/terminals', permission: Authorities.VIEW_AGENT_TERMINALS },
		{ path: 'agent/disputes', permission: '' },
		{ path: 'agent/cards', permission: '' },
		{ path: 'agent/wallet', permission: Authorities.VIEW_WALLET },
		{ path: 'agent/devices', permission: Authorities.VIEW_USER_DEVICES },

		{ path: 'aggregator/loans', permission: Authorities.AGGREGATOR_MANAGE_LOAN },
		{ path: 'aggregator/general/wallets', permission: '' },

	];
	getRoutesAndPermissionsArray(): Array<any> {
		return this.routesAndPermissions;
	}
}

export interface RouteConfig {
	path: string;
	permission: string;
}

export class Authorities {

	public static readonly VALIDATE_BVN = 'mab_fo_validate_bvn';

	public static readonly VIEW_LOANS = 'mab_fo_agent_manager_overdraft';

	public static readonly VALIDATE_TERMINAL_SERIAL_NUMBER = 'mab_fo_validate_terminal_serial_number';

	public static readonly VALIDATE_BANK_ACCT = 'mab_fo_validate_bank_account';

	public static readonly ADD_AGENTS = 'mab_fo_add_agents';

	public static readonly VIEW_AGENTS = 'mab_fo_view_agents';

	public static readonly VIEW_CONSOLIDATED_TRANSACTIONS = 'mab_fo_view_consolidated_transactions';

	public static readonly ACCEPT_INDEMNITY = 'mab_fo_accept_indemnity';

	public static readonly UPDATE_AGENTS = 'mab_fo_update_agents';

	public static readonly ADD_SUPER_AGGREGATORS = 'mab_fo_add_super_aggregators';

	public static readonly VIEW_SUPER_AGGREGATORS = 'mab_fo_view_super_aggregators';

	public static readonly VIEW_SUPER_AGGREGATORS_REPORTS = 'mab_fo_view_super_aggregators_reports';

	public static readonly ADD_AGGREGATORS = 'mab_fo_add_aggregators';

	public static readonly MANAGE_DISPUTES = 'mab_fo_manage_disputes';

	public static readonly MANAGE_TERMINAL_DISPUTES = 'mab_pos_manage_disputes';

	public static readonly VIEW_AGGREGATORS = 'mab_fo_view_aggregators';

	public static readonly VIEW_NEW_AGGREGATOR_REQUESTS = 'mab_fo_view_new_aggregator_requests';

	public static readonly VIEW_AGGREGATORS_REPORTS = 'mab_fo_view_aggregators_reports';

	public static readonly VIEW_WALLET = 'mab_fo_view_wallet';

	public static readonly WALLET_CASHOUT = 'mab_fo_wallet_cashout';

	public static readonly WEB_DEPOSIT = 'mab_fo_web_deposit';

	public static readonly VIEW_AGENT_TRANSACTIONS = 'mab_fo_view_agent_transactions';

	public static readonly VIEW_AGENT_TERMINALS = 'mab_fo_view_agent_terminals';

	public static readonly SUPER_AGGREGATOR_VIEW_AGENT_TERMINALS = 'mab_fo_super_aggregator_view_agent_terminals';

	public static readonly SUPER_AGGREGATOR_ASSIGN_TERMINAL_TO_AGENT = 'mab_fo_super_aggregator_assign_terminal_to_agent';

	public static readonly RETRIEVE_AGENT_TERMINALS = 'mab_fo_retrieve_agent_terminals';

	public static readonly SWAP_AGENT_TERMINALS = 'mab_fo_swap_agent_terminals';

	public static readonly ASSIGN_AGENT_TERMINALS = 'mab_fo_assign_agent_terminals';

	public static readonly VIEW_AGGREGATOR_TRANSACTIONS = 'mab_fo_view_aggregator_transactions';

	public static readonly FUNDS_PROVIDER_MANAGE_PROFILE = 'mab_fo_funds_provider_profile';

	public static readonly TERMINAL_OWNER_MANAGE_PROFILE = 'mab_fo_terminal_owner_profile';

	public static readonly SUPREME_AGGREGATOR_MANAGE_PROFILE = 'mab_fo_supreme_aggregator_profile';

	public static readonly SUPER_AGGREGATOR_MANAGE_PROFILE = 'mab_fo_super_aggregator_profile';

	public static readonly AGGREGATOR_MANAGE_PROFILE = 'mab_fo_aggregator_profile';

	public static readonly AGGREGATOR_MANAGE_LOAN = 'mab_fo_aggregator_manage_loans';

	public static readonly AGENT_MANAGER_MANAGE_PROFILE = 'mab_fo_agent_manager_profile';

	public static readonly AGENT_MANAGE_PROFILE = 'mab_fo_agent_profile';

	public static readonly UPDATE_PASSPHRASE = 'mab_fo_update_password';

	public static readonly VIEW_AGGREGATOR_TRANSACTION_DATA = 'mab_fo_view_aggregator_transaction_data';

	public static readonly VIEW_AGENT_TRANSACTION_DATA = 'mab_fo_view_agent_transaction_data';

	public static readonly VIEW_AGENT_MANAGER_TRANSACTIONS = 'mab_fo_view_agent_manager_transactions';

	public static readonly VIEW_WALLET_TRANSACTION = 'mab_fo_view_wallet_transaction';

	public static readonly VIEW_CASHOUT_TRANSACTIONS = 'mab_fo_view_cashout_transactions';

	public static readonly VIEW_AGGREGATOR_DASHBOARD = 'mab_fo_view_aggregator_dashboard';

	public static readonly VIEW_AGENT_DASHBOARD = 'mab_fo_view_agent_dashboard';

	public static readonly VIEW_SUPER_AGGREGATOR_DASHBOARD = 'mab_fo_view_super_aggregator_dashboard';

	public static readonly VIEW_AREAS = 'mab_fo_view_areas';

	public static readonly VIEW_PLATFORM_COMMISSION = 'mab_fo_view_platform_commission';

	public static readonly VIEW_SUPREME_AGGREGATOR_COMMISSION = 'mab_fo_view_supreme_aggregator_commission';

	public static readonly VIEW_SUPER_AGGREGATOR_COMMISSION = 'mab_fo_view_super_aggregator_commission';

	public static readonly APPROVE_AGENTS = 'mab_fo_approve_agents';

	public static readonly SUPER_AGGREGATOR_ASSIGN_AGGREGATOR_TERMINALS = 'mab_fo_super_aggregator_assign_terminals_to_aggregators';

	public static readonly SUPER_AGGREGATOR_COLLECT_TERMINALS = 'mab_fo_super_aggregator_collect_terminals';

	public static readonly FUND_WALLET = 'mab_fo_fund_wallet';

	public static readonly ACTIVATE_USER_DEVICE = 'mab_fo_activate_user_device';

	public static readonly RESEND_OTP_FOR_USER_DEVICE_ACTIVATION = 'mab_fo_resend_otp_for_user_device_activation';

	public static readonly VIEW_USER_DEVICES = 'mab_fo_view_user_devices';

	public static readonly UPDATE_USER_DEVICE_STATE = 'mab_fo_update_user_device_state';

	public static readonly VIEW_AIRTIME_TRANSACTIONS = 'mab_fo_can_view_airtime_transactions';

	public static readonly VIEW_SUPREME_AGGREGATOR_DASHBOARD = 'mab_fo_view_supreme_aggregator_dashboard';

	public static readonly VIEW_AGENT_MANAGER_DASHBOARD = 'mab_fo_view_agent_manager_dashboard';

	public static readonly VIEW_AGGREGATOR_TERMINALS = 'mab_fo_view_aggregator_terminals';

	public static readonly SUPER_AGGREGATOR_VIEW_AGGREGATOR_TERMINALS = 'mab_fo_view_aggregator_terminals';

	public static readonly SUPREME_AGGREGATOR_ASSIGN_SUPER_AGGREGATOR_TERMINALS = 'mab_fo_supreme_aggregator_assign_terminals_to_super_aggregators';

	public static readonly SUPREME_AGGREGATOR_COLLECT_TERMINALS = 'mab_fo_supreme_aggregator_collect_terminals';

	public static readonly GET_AGENTS_LOCATION = 'mab_fo_get_agents_location';

	public static readonly MANAGE_AGENTS_LOCATION = 'mab_fo_manage_agents_location';

	public static readonly WEB_AIRTIME_PURCHASE = 'mab_fo_web_airtime_purchase';

	public static readonly VIEW_AIRTIME_NETWORKS = 'mab_fo_view_airtime_networks';

	public static readonly VIEW_AGGREGATOR_TERMINAL_ASSIGNMENT_REQUESTS = 'mab_fo_view_aggregator_terminal_assignment_requests';

	public static readonly VIEW_SUPREME_AGGREGATOR_TERMINAL_ASSIGNMENT_REQUESTS = 'mab_fo_view_supreme_aggregator_terminal_assignment_requests';

	public static readonly PROCESS_TERMINAL_ASSIGNMENT_REQUESTS = 'mab_fo_process_terminal_assignment_requests';

	public static readonly UPDATE_TERMINAL_ASSIGNMENT_REQUESTS = 'mab_fo_update_terminal_assignment_requests';

	public static readonly WEB_BILL_PAYMENT = 'mab_fo_web_bill_payment';

	public static readonly MANAGE_BILLERS = 'mab_fo_manage_billers';

	public static readonly UPDATE_KYC = 'mab_fo_update_kyc';

	public static readonly SEND_PIN_RESET_OTP = 'mab_fo_send_pin_reset_otp';

	public static readonly VIEW_AGGREGATOR_REQUESTS = 'mab_fo_view_aggregator_requests';

	public static readonly PROCESS_AGGREGATOR_REQUESTS = 'mab_fo_process_aggregator_requests';

	public static readonly SUPER_AGGREGATORS_VIEW_AGENTS = 'mab_fo_super_aggregators_view_agents';

	public static readonly MANAGE_AGENT_LIMIT_PROFILE = 'mab_fo_manage_agent_limit_profile';

	public static readonly RETRY_CARD_TRANSFER_TRANSACTION = 'mab_fo_retry_card_transfer_transaction';

	public static readonly GENERATE_USSD_CODE = 'mab_fo_generate_ussd_otp_code';

	public static readonly END_CARD_TRANSFER_TRANSACTION = 'mab_fo_end_card_transfer_transaction';

}
